<footer class="govbook-footer">
	<div class="govbook-footer__footer">
		<div class="govuk-width-container">
			<div class="row">
				<div class="col-sm-12 col-md-2 col-lg-2 brand-area">
					<img class="logo" src="westminster-logo.png" alt="City of Westminster logo" />
				</div>
				<div class="col-sm-12 col-md-8 col-lg-8 navigation">
					<img class="adtr-img" src="wcc-nav-brand.svg" alt="A day to remember">
					<ul class="block block-menu menu">
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.adaytoremember.london/privacy-policy"
								>Privacy notice</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.adaytoremember.london/terms-and-conditions"
								>Terms of use</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.adaytoremember.london/cookie-policy"
								>Cookies and your privacy</a
							>
						</li>
					</ul>
				</div>
				<div class="col-sm-12 col-md-2 col-lg-2 brand-area">
					<ul class="menu menu--social-media">
								<li class="menu-item">
							<a target="_blank" aria-label="Instagram (opens in new window)" class="footer-links"
								href="https://www.instagram.com/adaytorememberlondon" class="social-link instagram"><img
									src="instagram.svg" alt="instagram logo" /></a>
						</li>
						<li class="menu-item">
							<a target="_blank" aria-label="Facebook (opens in new window)" class="footer-links"
								href="https://www.facebook.com/WestminsterRegisterOffice"
								class=" social-link facebook">
								<img src="facebook.svg" alt="facebook logo" /></a>
						</li>
						<li class="menu-item">
							<a target="_blank" aria-label="FAQ (opens in new window)" class="footer-links"
								href="#" class="social-link"><img src="contact_support.svg"
									alt="FAQ Icon" /></a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</footer>
